import { Auth } from 'aws-amplify';
import { getSsoToken } from './ssoSession';
import { getLocalToken } from './localSession';

/**
 * Gets the JWT from the current user's session.
 * Handles local development with a mock token if configured.
 * @returns {Promise<string | null>} The JWT token or null if no session exists.
 */
export async function getAuthToken(): Promise<string | null> {
  // External-SSO session (e.g. Odoo handoff) wins when present; Cognito
  // users never have one, so their flow is unchanged.
  const ssoToken = getSsoToken();
  if (ssoToken) return ssoToken;
  // Local password session (Core CORE_AUTH_MODE=local); absent for Cognito users.
  const localToken = getLocalToken();
  if (localToken) return localToken;

  // In development mode, always bypass real authentication and return a mock token.
  if (import.meta.env.DEV) {
    console.log('[Auth] getAuthToken: Bypassing real authentication for local dev. Returning mock token.');
    return 'mock-dev-token';
  }

  // Otherwise, try to get a real token
  try {
    const session = await Auth.currentSession();
    return session.getIdToken().getJwtToken();
  } catch (error) {
    console.warn('[Auth] getAuthToken: No active user session, or error fetching real token:', error);
    return null;
  }
} 